// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1oNIh","content":"styles_content__3EdX2"};